module.exports = __webpack_public_path__ + "img/loginLO.80fb4085.svg";